import getColor from "@insite/mobius/utilities/getColor";
import { signInCreateNewAccountStyles } from "@waytek/Overrides/Widgets/SignIn/SignInCreateNewAccount";
import { fontFamily, mediaQueriesBP } from "@waytek/Utilities/variables";
import { css } from "styled-components";

const localColors = {
    globalIndustrialTaupe: getColor("common.global.industrialTaupe"),
};

signInCreateNewAccountStyles.signInCreateNewAccountGridContainer = {
    ...signInCreateNewAccountStyles.signInCreateNewAccountGridContainer,
    css: css`
        ${mediaQueriesBP.minLG} {
            padding-left: 30px;
        }
    `,
};

signInCreateNewAccountStyles.signInCreateNewAccountTitleGridItem = {
    ...signInCreateNewAccountStyles.signInCreateNewAccountTitleGridItem,
    css: css`
        padding-bottom: 10px;
    `,
};

signInCreateNewAccountStyles.signInCreateNewAccountTitle = {
    ...signInCreateNewAccountStyles.signInCreateNewAccountTitle,
    fontFamily,
    css: css`
        flex: 1;
        border-bottom: solid 3px ${localColors.globalIndustrialTaupe};
        padding-bottom: 5px;
    `,
};

signInCreateNewAccountStyles.signInCreateNewAccountTextGridItem = {
    ...signInCreateNewAccountStyles.signInCreateNewAccountTextGridItem,
    css: css`
        padding-top: 10px;

        ${mediaQueriesBP.minLG} {
            padding-bottom: 20px;
        }
    `,
};

signInCreateNewAccountStyles.signInCreateNewAccountText = {
    ...signInCreateNewAccountStyles.signInCreateNewAccountText,
    css: css`
        * {
            &:last-child {
                margin-bottom: 0;
            }
        }

        ul,
        ol {
            font-size: 16px;

            ${mediaQueriesBP.maxMD} {
                font-size: 14px;
            }

            ${mediaQueriesBP.maxLG} {
                padding-left: 20px;
            }
        }
    `,
};

signInCreateNewAccountStyles.signInCreateNewAccountButtonGridItem = {
    ...signInCreateNewAccountStyles.signInCreateNewAccountButtonGridItem,
    css: css`
        flex-wrap: wrap;

        ${mediaQueriesBP.minLG} {
            padding-top: 20px;
        }
    `,
};

signInCreateNewAccountStyles.createNewAccountButton = {
    ...signInCreateNewAccountStyles.createNewAccountButton,
    variant: "primary",
    mergeCss: true,
    css: css`
        ${mediaQueriesBP.maxMD} {
            min-width: 100%;
            width: 100%;
        }
    `,
};

signInCreateNewAccountStyles.checkoutAsGuestButton = {
    ...signInCreateNewAccountStyles.checkoutAsGuestButton,
    variant: "secondary",
    css: css`
        margin-left: 20px;

        ${mediaQueriesBP.maxMD} {
            width: 100%;
            margin-left: 0;
            margin-top: 20px;
        }
    `,
};
